// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hs-0";
export var actionModalContentContainer = "_hs-1";
export var createTagButton = "_hs-2";
export var footerContainer = "_hs-7";
export var fullWidthDivider = "_hs-3";
export var hasCreateTagButton = "_hs-4";
export var noCreateTagButton = "_hs-5";
export var tagsContainer = "_hs-6";
export var tagsModalContentContainer = "_hs-8";